document.addEventListener('DOMContentLoaded', () => {
  // Seleccionar los elementos del menú para desktop y mobile
  const desktopMenuItems = document.querySelectorAll('.header__inline-menu .list-menu--inline > li');
  const mobileMenuItems = document.querySelectorAll('.menu-drawer__navigation .menu-drawer__menu > li');

  // Iterar sobre la configuración del menú
  menuConfig.forEach(config => {
    let menuItemDesktop = null;
    let menuItemMobile = null;

    // Identificar el elemento según la posición
    if (config.position === 1) {
      // Primer elemento
      menuItemDesktop = desktopMenuItems[0];
      menuItemMobile = mobileMenuItems[0];
    } else if (config.position === 99) {
      // Último elemento
      menuItemDesktop = desktopMenuItems[desktopMenuItems.length - 1];
      menuItemMobile = mobileMenuItems[mobileMenuItems.length - 1];
    } else if (config.position > 1 && config.position <= desktopMenuItems.length) {
      // Posición intermedia
      menuItemDesktop = desktopMenuItems[config.position - 1];
      menuItemMobile = mobileMenuItems[config.position - 1];
    }

if (menuItemDesktop) {
      const linkDesktop = menuItemDesktop.querySelector('span');
      if (linkDesktop) {
        linkDesktop.style.color = config.color;

        if (config.animation) {
          const textWidth = linkDesktop.offsetWidth; // Obtener el ancho del texto
          const animationClass = config.position === 1 || config.position === 99 ? 'animated-gradient-desktop' : 'animated-gradient-desktop-intermediate';
          linkDesktop.classList.add(animationClass);

          // Crear un estilo dinámico para este elemento específico
          const style = document.createElement('style');
          style.textContent = `
            .${animationClass}[data-id="${config.position}"]:after {
              width: ${textWidth}px !important;
            }
          `;
          document.head.appendChild(style);

          // Asignar un identificador único al elemento
          linkDesktop.setAttribute('data-id', config.position);
        }
      }
    }
    // Aplicar color y animación a mobile
    if (menuItemMobile) {
      const linkMobile = menuItemMobile.querySelector('a, span, details > summary > span ');
      if (linkMobile) {
        linkMobile.style.color = config.color; // Cambiar el color
      }
      if (config.animation) {
        menuItemMobile.classList.add('animated-gradient-mobile');
      }
    }
  });
});
